export enum RevisedTraumaScoreConstants {
  SET_RTS_BP = 'revisedTraumaScore/SET_RTS_BP',
  SET_RTS_RESP = 'revisedTraumaScore/SET_RTS_RESP',
  SET_RTS = 'revisedTraumaScore/SET_RTS',
  SET_RTS_DATA = 'revisedTraumaScore/SET_RTS_DATA',
  RESET_RTS_DATA = 'revisedTraumaScore/RESET_RTS_DATA',
  SAVE_RTS_DATA = 'revisedTraumaScore/SAVE_RTS_DATA',
}
